import { getUserPersona } from "@/utils/helper"
import {
  UPSELL_PRODUCT,
  QUICK_VIEW,
  CLOSE,
  QUICK_VIEW_MODAL,
  SEARCH_RESULTS,
  PLP,
  ADD_TO_CART,
  VIEW_FULL_DETAILS,
  DIMENSIONS,
  COLOR_SELECTION,
  LIST_PRICE,
  CAROUSEL_IMAGE,
  REVIEW,
  Download,
  NOTIFY,
  SPEC_SHEET,
  GUIDE,
  DOWNLOADS,
  BUNDLE,
  PDP,
  PRODUCT_DETAILS,
} from "@/components/Shared/QuickView/constant.js"

const getProductInfo = data => {
  const {
    brandName,
    productName,
    productDesc,
    skuID,
    category,
    pdpType,
    productPrice,
    discountedPrice,
    productImageUrl,
  } = data
  const productInfo = {
    category: category,
    description: productDesc,
    frequency: "n/a",
    globalPromotionPrice:
      discountedPrice > 0
        ? Number((discountedPrice - 0).toFixed(2))
        : productPrice,
    globalOffer: "n/a",
    globalDiscount: Number(discountedPrice.toFixed(2)),
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    priceState: discountedPrice ? "discounted price" : "regular price",
    productBasePrice: Number(productPrice),
    productCategory: category,
    productColor: "default",
    productCoupondiscount: "n/a",
    productCouponCode: "n/a",
    productID: skuID,
    productName: productName || productDesc || category || "n/a",
    productPartnerBuyNow: "n/a",
    productRoom: "product",
    productSalePrice:
      discountedPrice > 0
        ? Number((discountedPrice - 0).toFixed(2))
        : productPrice,
    productSaleable: true,
    productStatus: "in stock",
    productSuperSku: false,
    productTileName: productName,
    quantity: 1,
    defaultImageName: productImageUrl || "n/a",
    ratings: "n/a",
    numberOfReviews: "n/a",
    pdpType: pdpType || "regular finished goods & service parts",
    productFindingMethod: "n/a",
    productCollectionsName: productName,
    productBrand: brandName,
    itemType: "product",
    waterSenseProduct: false,
  }
  return productInfo
}

const getEventInfo = (upshellmodal = false) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const pageTypeObj = page.category
  let pageTypeText = ""

  let pageName = ""
  let recommTitle = ""
  let upshellTitle = ""

  if (pageTypeObj?.subCategoryID === "cart") {
    pageName = "cart"
    pageTypeText = upshellmodal ? "cart preview" : pageName
    recommTitle = upshellmodal !== true ? ":recommended additions" : ""
    upshellTitle = upshellmodal ? ":our best sellers" : ":recommended additions"
  }
  if (pageTypeObj?.pageType === "pdp") {
    pageName = "pdp"
    pageTypeText = "pdp"
    recommTitle = ":we recommend"
    upshellTitle = ":we recommend"
  }
  return { pageTypeText, pageName, recommTitle, upshellTitle }
}

export const quickViewOpenAnalytics = data => {
  const {
    productData,
    productUrl = "",
    productImageUrl = "",
    upshellmodal = false,
    recommendationSource = "n/a",
    isMultifinishBundle = false,
    optionCategory = "",
    commonProductInfo = {},
  } = data
  let eventInfo = {}
  let productInfo = {}
  const persona = getUserPersona()

  if (isMultifinishBundle) {
    eventInfo = {
      eventAction: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}:${QUICK_VIEW}`,
      eventMsg: "n/a",
      eventName: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}:${QUICK_VIEW}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: QUICK_VIEW,
      internalLinkPosition: `${PDP}:${BUNDLE}`,
      internalLinkType: `${PDP}:${QUICK_VIEW}`,
      clickInternalLinks: "true",
      internalLinkURL: "n/a",
      internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW}`,
      modalName: `${BUNDLE}:${QUICK_VIEW}`,
    }

    productInfo = [{ ...productData, ...commonProductInfo }]
  } else {
    const {
      CustomerFacingBrand_s: brandName = "",
      sku_s: skuID = "",
      ProductBrandName_s: productName = "",
      ProductDescriptionProductShort_s: productDesc = "",
      Product_Category: category = "",
      [`priceList.${persona}.price_d`]: productPrice = 0,
      [`priceList.${persona}.discountedPrice_d`]: discountedPrice = 0,
    } = productData

    productInfo = getProductInfo({
      brandName,
      productName,
      productDesc,
      skuID,
      category,
      productPrice,
      discountedPrice,
      productImageUrl,
      productUrl,
    })

    const { pageTypeText, pageName, recommTitle, upshellTitle } =
      getEventInfo(upshellmodal)

    eventInfo = {
      clickInternalLinks: "true",
      curatedRecommendation: recommendationSource,
      eventAction: `${pageTypeText}:${UPSELL_PRODUCT}${recommTitle}:${QUICK_VIEW}`,
      eventMsg: "n/a",
      eventName: `${pageTypeText}:${UPSELL_PRODUCT}${recommTitle}:${QUICK_VIEW}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: QUICK_VIEW,
      internalLinkPosition: `${pageTypeText}:upsell`,
      internalLinkType: `${pageName}:${QUICK_VIEW}`,
      internalLinkURL: productUrl || "n/a",
      internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW}`,
      modalName: QUICK_VIEW_MODAL,
    }
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}
export const quickViewCloseAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    productUrl = "",
    isMultifinishBundle = false,
    optionCategory = "",
  } = data
  let eventInfo = {}

  if (isMultifinishBundle) {
    eventInfo = {
      eventAction: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}:${QUICK_VIEW_MODAL}:${CLOSE}`,
      eventMsg: "n/a",
      eventName: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}:${QUICK_VIEW_MODAL}:${CLOSE}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: CLOSE,
      internalLinkPosition: `${PDP}:${BUNDLE}`,
      internalLinkType: `${PDP}:${QUICK_VIEW_MODAL}`,
      clickInternalLinks: "true",
      internalLinkURL: "n/a",
      internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW_MODAL}:${CLOSE}`,
      modalName: `${BUNDLE}:${QUICK_VIEW}`,
    }
  } else {
    const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)

    eventInfo = {
      clickInternalLinks: "true",
      curatedRecommendation: recommendationSource,
      eventAction: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${CLOSE}`,
      eventMsg: "n/a",
      eventName: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${CLOSE}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: CLOSE,
      internalLinkPosition: `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}`,
      internalLinkType: `${pageName}:${QUICK_VIEW_MODAL}`,
      internalLinkURL: productUrl || "n/a",
      internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}`,
      modalName: QUICK_VIEW_MODAL,
    }
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewAddToCartAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    plp = false,
    search = false,
  } = data

  const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)
  const eventNameAndAction = plp
    ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${ADD_TO_CART}`
    : `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${ADD_TO_CART}`
  const eventInfo = {
    clickInternalLinks: "true",
    curatedRecommendation: recommendationSource,
    eventAction: eventNameAndAction,
    eventMsg: "n/a",
    eventName: eventNameAndAction,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: ADD_TO_CART,
    internalLinkPosition: plp
      ? `${search ? SEARCH_RESULTS : PLP}:promo tile:${QUICK_VIEW_MODAL}`
      : `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}`,
    internalLinkType: plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}`
      : `${pageName}:${QUICK_VIEW_MODAL}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${ADD_TO_CART}`
      : `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${ADD_TO_CART}`,
    modalName: QUICK_VIEW_MODAL,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const viewFullDetailsAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    isMultifinishBundle = false,
    productOptionCategory = "",
    productUrl = "",
    plp = false,
    search = false,
  } = data

  const eventInfo = createQuickViewEventInfo({
    isMultifinishBundle,
    actionType: VIEW_FULL_DETAILS,
    productOptionCategory,
    upshellmodal,
    recommendationSource,
    productUrl,
    plp,
    search,
  })

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewDimensionsAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    dimensionsValue = {},
    isMultifinishBundle = false,
    productOptionCategory = "",
  } = data

  let eventInfo = {}
  const {
    tooltip = "",
    label = "",
    value = "",
    formattedValue,
  } = dimensionsValue
  const analyticsValue = formattedValue ?? value
  const normalizedLabel = String(label ?? "").toLowerCase()
  const normalizedValue = String(analyticsValue ?? "").toLowerCase()

  if (isMultifinishBundle) {
    eventInfo = {
      eventAction: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${DIMENSIONS} mouseover`,
      eventMsg: "n/a",
      eventName: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${DIMENSIONS} mouseover`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: tooltip,
      internalLinkPosition: `${PDP}:${BUNDLE}`,
      internalLinkType: `${PDP}:${QUICK_VIEW_MODAL}`,
      clickInternalLinks: "true",
      internalLinkURL: "n/a",
      internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW_MODAL}:${DIMENSIONS} mouseover`,
      modalName: `${BUNDLE}:${QUICK_VIEW}`,
    }
  } else {
    const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)

    eventInfo = {
      clickInternalLinks: "true",
      curatedRecommendation: recommendationSource,
      eventAction: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${DIMENSIONS} mouseover`,
      eventMsg: "n/a",
      eventName: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${DIMENSIONS} mouseover`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: tooltip,
      internalLinkPosition: `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}:${DIMENSIONS}:${normalizedLabel} ${normalizedValue}`,
      internalLinkType: `${pageName}:${QUICK_VIEW_MODAL}`,
      internalLinkURL: "n/a",
      internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${DIMENSIONS}`,
      modalName: QUICK_VIEW_MODAL,
    }
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewVaraintClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    assetId,
    label,
    isMultifinishBundle = false,
    productOptionCategory = "",
  } = data

  const eventInfo = createQuickViewEventInfo({
    isMultifinishBundle,
    actionType: COLOR_SELECTION,
    productOptionCategory,
    upshellmodal,
    recommendationSource,
    assetData: { assetId, label },
  })

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewListPriceAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    listPriceInfo,
    isMultifinishBundle = false,
    productOptionCategory = "",
  } = data
  let eventInfo = {}
  if (isMultifinishBundle) {
    eventInfo = {
      eventAction: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${LIST_PRICE} mouseover`,
      eventMsg: "n/a",
      eventName: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${LIST_PRICE} mouseover`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: listPriceInfo,
      internalLinkPosition: `${PDP}:${BUNDLE}`,
      internalLinkType: `${PDP}:${QUICK_VIEW_MODAL}`,
      clickInternalLinks: "true",
      internalLinkURL: "n/a",
      internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW_MODAL}:${LIST_PRICE} mouseover`,
      modalName: `${BUNDLE}:${QUICK_VIEW}`,
    }
  } else {
    const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)

    eventInfo = {
      clickInternalLinks: "true",
      curatedRecommendation: recommendationSource,
      eventAction: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${LIST_PRICE} mouseover`,
      eventMsg: "n/a",
      eventName: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${LIST_PRICE}  mouseover`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: listPriceInfo,
      internalLinkPosition: `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}:${LIST_PRICE} hover`,
      internalLinkType: `${pageName}:${QUICK_VIEW_MODAL}`,
      internalLinkURL: "n/a",
      internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${LIST_PRICE}`,
      modalName: QUICK_VIEW_MODAL,
    }
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewPrevNextCarouselButtonClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    btnType = "",
    isMultifinishBundle = false,
    productOptionCategory = "",
    plp = false,
    search = false,
  } = data
  const eventInfo = createQuickViewEventInfo({
    isMultifinishBundle,
    actionType: `${CAROUSEL_IMAGE}:${btnType}`,
    productOptionCategory,
    upshellmodal,
    recommendationSource,
    additionalFields: {
      internalLinkName: `${btnType} arrow`,
    },
    plp,
    search,
  })

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewCarouselImageClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    assetId,
    imageSequence,
    resourceType,
    imageName,
    isMultifinishBundle = false,
    productOptionCategory = "",
    plp = false,
    search = false,
  } = data

  const eventInfo = createQuickViewEventInfo({
    isMultifinishBundle,
    actionType: CAROUSEL_IMAGE,
    productOptionCategory,
    upshellmodal,
    recommendationSource,
    additionalFields: {
      internalLinkName: assetId,
      imageId: assetId,
      imageName: imageName,
      resourceType: resourceType,
      imageSequence: imageSequence,
    },
    plp,
    search,
  })
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewReviewClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    redirectUrl,
  } = data
  const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)

  const eventInfo = {
    clickInternalLinks: "true",
    curatedRecommendation: recommendationSource,
    eventAction: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${REVIEW}`,
    eventMsg: "n/a",
    eventName: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${REVIEW}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: REVIEW,
    internalLinkPosition: `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}`,
    internalLinkType: `${pageName}:${QUICK_VIEW_MODAL}`,
    internalLinkURL: window.location.origin + redirectUrl,
    internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${REVIEW}`,
    modalName: QUICK_VIEW_MODAL,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewDownloadClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    title = "",
    url = "",
    isMultifinishBundle = false,
    productOptionCategory = "",
  } = data
  let eventInfo = {}
  const downloadTitle = title.toLowerCase()?.includes("specifications")
    ? SPEC_SHEET
    : GUIDE
  if (isMultifinishBundle) {
    eventInfo = {
      eventAction: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${DOWNLOADS}:${downloadTitle}`,
      eventMsg: "n/a",
      eventName: `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${DOWNLOADS}:${downloadTitle}`,
      eventStatus: "n/a",
      eventType: "navigation",
      internalLinkName: `${downloadTitle} | ${url}`,
      internalLinkPosition: `${PDP}:${BUNDLE}`,
      internalLinkType: `${PDP}:${QUICK_VIEW_MODAL}`,
      clickInternalLinks: "true",
      internalLinkURL: "n/a",
      internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW_MODAL}:${DOWNLOADS}`,
      modalName: `${BUNDLE}:${QUICK_VIEW}`,
    }
  } else {
    const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)
    eventInfo = {
      clickInternalLinks: "true",
      curatedRecommendation: recommendationSource,
      eventAction: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${Download}:${downloadTitle}`,
      eventMsg: "n/a",
      eventName: `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${Download}:${downloadTitle}`,
      eventStatus: "success",
      eventType: "navigation",
      internalLinkName: `${downloadTitle} | ${url}`,
      internalLinkPosition: `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}`,
      internalLinkType: `${pageName}:${QUICK_VIEW_MODAL}`,
      internalLinkURL: "n/a",
      internalLinkZoneName: `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${Download}s`,
      modalName: QUICK_VIEW_MODAL,
    }
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const quickViewNotifyMeClickAnalytics = data => {
  const {
    productInfo = {},
    upshellmodal = false,
    recommendationSource = "n/a",
    isSuccess,
    errorMsgQV,
    isMultifinishBundle = false,
    productOptionCategory = "",
    plp = false,
    search = false,
  } = data

  const eventInfo = createQuickViewEventInfo({
    isMultifinishBundle,
    actionType: NOTIFY,
    productOptionCategory,
    upshellmodal,
    recommendationSource,
    additionalFields: {
      internalLinkName: NOTIFY,
      formName: NOTIFY,
    },
    eventStatus: isSuccess ? "success" : "failure",
    eventMsg: !isSuccess ? errorMsgQV : "n/a",
    plp,
    search,
  })

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const createQuickViewEventInfo = ({
  isMultifinishBundle = false,
  actionType,
  productOptionCategory = "",
  upshellmodal = false,
  recommendationSource = "n/a",
  additionalFields = {},
  productUrl = "",
  eventStatus = "n/a",
  eventMsg = "n/a",
  plp = false,
  search = false,
}) => {
  if (isMultifinishBundle) {
    return createBundleEventInfo({
      actionType,
      productOptionCategory,
      productUrl,
      additionalFields,
      eventStatus,
      eventMsg,
      plp,
      search,
    })
  }

  return createStandardEventInfo({
    actionType,
    upshellmodal,
    recommendationSource,
    additionalFields,
    productUrl,
    eventStatus,
    eventMsg,
    plp,
    search,
  })
}

// Helper function for bundle product event info
const createBundleEventInfo = ({
  actionType,
  productOptionCategory = "",
  productUrl = "",
  additionalFields = {},
  eventStatus = "n/a",
  eventMsg = "n/a",
  plp = false,
  search = false,
}) => {
  let actionPattern = plp
    ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${actionType}`
    : `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${actionType}`

  const specialActions = {
    [CAROUSEL_IMAGE]: action => `${action} click`,
    [DIMENSIONS]: action => `${action} mouseover`,
    [LIST_PRICE]: action => `${action} mouseover`,
  }
  if (specialActions[actionType]) {
    actionPattern = plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${specialActions[
          actionType
        ](actionType)}`
      : `${PDP}:${PRODUCT_DETAILS}:${productOptionCategory}:${QUICK_VIEW_MODAL}:${specialActions[
          actionType
        ](actionType)}`
  }

  return {
    clickInternalLinks: "true",
    eventAction: actionPattern,
    eventMsg: eventMsg,
    eventName: actionPattern,
    eventStatus: eventStatus,
    eventType: "navigation",
    internalLinkName: actionType,
    internalLinkPosition: plp
      ? `${search ? SEARCH_RESULTS : PLP}:promo tile:${QUICK_VIEW_MODAL}`
      : `${PDP}:${BUNDLE}`,
    internalLinkType: plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}`
      : `${PDP}:${QUICK_VIEW_MODAL}`,
    internalLinkURL: productUrl || "n/a",
    internalLinkZoneName: plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${actionType}`
      : `${PDP}:${PRODUCT_DETAILS}:${QUICK_VIEW_MODAL}:${actionType}`,
    modalName: `${BUNDLE}:${QUICK_VIEW}`,
    ...additionalFields,
  }
}

// Helper function for standard product event info
const createStandardEventInfo = ({
  actionType,
  upshellmodal,
  recommendationSource,
  additionalFields = {},
  productUrl = "",
  eventStatus = "n/a",
  eventMsg = "n/a",
  plp = false,
  search = false,
}) => {
  const { pageTypeText, pageName, upshellTitle } = getEventInfo(upshellmodal)

  const specialActions = {
    [CAROUSEL_IMAGE]: action => `${action} click`,
    [DIMENSIONS]: action => `${action} mouseover`,
    [LIST_PRICE]: action => `${action} mouseover`,
  }
  let baseAction = plp
    ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${actionType}`
    : `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${actionType}`

  if (specialActions[actionType]) {
    baseAction = plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${specialActions[
          actionType
        ](actionType)}`
      : `${pageTypeText}:${UPSELL_PRODUCT}:${QUICK_VIEW_MODAL}:${specialActions[
          actionType
        ](actionType)}`
  }

  return {
    clickInternalLinks: "true",
    curatedRecommendation: recommendationSource,
    eventAction: baseAction,
    eventMsg: eventMsg,
    eventName: baseAction,
    eventStatus: eventStatus,
    eventType: "navigation",
    internalLinkName: actionType,
    internalLinkPosition: plp
      ? `${search ? SEARCH_RESULTS : PLP}:promo tile:${QUICK_VIEW_MODAL}`
      : `${pageTypeText}:upsell:${QUICK_VIEW_MODAL}`,
    internalLinkType: plp
      ? `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}`
      : `${pageName}:${QUICK_VIEW_MODAL}`,
    internalLinkURL: productUrl || "n/a",
    internalLinkZoneName: plp
      ? (() => {
          if (actionType.includes(CAROUSEL_IMAGE)) {
            return `${search ? SEARCH_RESULTS : PLP}:${QUICK_VIEW_MODAL}:${
              actionType.split(":")[0]
            }`
          }
          return `${
            search ? SEARCH_RESULTS : PLP
          }:${QUICK_VIEW_MODAL}:${actionType}`
        })()
      : `${pageTypeText}${upshellTitle}:${QUICK_VIEW_MODAL}:${actionType}`,
    modalName: QUICK_VIEW_MODAL,
    ...additionalFields,
  }
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = {}) => {
  const page = window.pageObj || {}

  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}
